import { SectionId, SectionType, UIInstrumentType } from '../types';

export interface SectionConfig {
  id: SectionId;
  title: string;
  type: SectionType;
  visibleInInstrumentTypes: UIInstrumentType[];
}

export const SECTION_CONFIGS: SectionConfig[] = [
  {
    id: SectionId.INSTRUMENT_IDENTIFIERS,
    title: 'Instrument Identifiers',
    type: SectionType.COLUMN_MAPPING,
    visibleInInstrumentTypes: [
      'Option',
      'Transfer',
      'Dividend',
      'Deposit/Withdraw',
      'FX Spot'
    ],
  },
  {
    id: SectionId.FEE_TYPE,
    title: 'Fee Type',
    type: SectionType.MULTI_COLUMN_RULES_WITH_CATEGORIES,
    visibleInInstrumentTypes: ['Cash Adjustments'],
  },
  {
    id: SectionId.DEDUCTION_REBATE,
    title: 'Deduction/Rebate',
    type: SectionType.MULTI_COLUMN_RULES_WITH_CATEGORIES,
    visibleInInstrumentTypes: ['Cash Adjustments'],
  },
  {
    id: SectionId.DEPOSIT_WITHDRAW_TYPE,
    title: 'Deposit/Withdraw Type',
    type: SectionType.MULTI_COLUMN_RULES_WITH_CATEGORIES,
    visibleInInstrumentTypes: ['Deposit/Withdraw'],
  },
  {
    id: SectionId.FX_SPOT_TYPE,
    title: 'FX Spot Type',
    type: SectionType.MULTI_COLUMN_RULES_WITH_CATEGORIES,
    visibleInInstrumentTypes: ['FX Spot'],
  },
  {
    id: SectionId.TRANSACTION_DATE,
    title: 'Transaction Date',
    type: SectionType.SINGLE_COLUMN_WITH_DATE,
    visibleInInstrumentTypes: [
      'Equities',
      'Funds & ETFs',
      'FixedIncome',
      'Option',
      'FX Spot',
      'Deposit/Withdraw',
      'Transfer',
      'Cash Adjustments',
    ],
  },
  {
    id: SectionId.SETTLEMENT_DATE,
    title: 'Settlement Date',
    type: SectionType.SINGLE_COLUMN_WITH_DATE,
    visibleInInstrumentTypes: ['FixedIncome'],
  },
  {
    id: SectionId.SYMBOL_ISIN,
    title: 'Symbol/ISIN',
    type: SectionType.SINGLE_COLUMN,
    visibleInInstrumentTypes: [],
  },
  {
    id: SectionId.BUY_SELL,
    title: 'Buy/Sell',
    type: SectionType.MULTI_COLUMN_RULES_WITH_CATEGORIES,
    visibleInInstrumentTypes: [
      'Equities',
      'Funds & ETFs',
      'FixedIncome',
      'Option',
    ],
  },
  {
    id: SectionId.QUANTITY,
    title: 'Quantity',
    type: SectionType.SINGLE_COLUMN,
    visibleInInstrumentTypes: [
      'Equities',
      'Funds & ETFs',
      'FixedIncome',
      'Option',
      'Deposit/Withdraw',
      'Transfer',
    ],
  },
  {
    id: SectionId.QUANTITY,
    title: 'Quantity',
    type: SectionType.MATH_OPERATIONS,
    visibleInInstrumentTypes: ['Cash Adjustments'],
  },
  {
    id: SectionId.CURRENCY,
    title: 'Currency',
    type: SectionType.CURRENCY,
    visibleInInstrumentTypes: [
      'Equities',
      'Funds & ETFs',
      'FixedIncome',
      'Option',
      'Deposit/Withdraw',
      'Transfer',
      'Cash Adjustments',
      'Dividend',
    ],
  },
  {
    id: SectionId.PRICE,
    title: 'Price',
    type: SectionType.SINGLE_COLUMN,
    visibleInInstrumentTypes: [
      'Equities',
      'Funds & ETFs',
      'FixedIncome',
      'Option',
    ],
  },
  {
    id: SectionId.STRIKE_PRICE,
    title: 'Strike Price',
    type: SectionType.SINGLE_COLUMN,
    visibleInInstrumentTypes: ['Option'],
  },
  {
    id: SectionId.EXPIRATION_DATE,
    title: 'Expiration Date',
    type: SectionType.SINGLE_COLUMN_WITH_DATE,
    visibleInInstrumentTypes: ['Option'],
  },
  {
    id: SectionId.OPTION_TYPE,
    title: 'Option Type',
    type: SectionType.SINGLE_COLUMN,
    visibleInInstrumentTypes: ['Option'],
  },
  {
    id: SectionId.UNDERLYING_SYMBOL,
    title: 'Underlying Symbol',
    type: SectionType.SINGLE_COLUMN,
    visibleInInstrumentTypes: ['Option'],
  },
  {
    id: SectionId.BUY_QUANTITY,
    title: 'Buy Quantity',
    type: SectionType.SINGLE_COLUMN,
    visibleInInstrumentTypes: ['FX Spot'],
  },
  {
    id: SectionId.SELL_QUANTITY,
    title: 'Sell Quantity',
    type: SectionType.SINGLE_COLUMN,
    visibleInInstrumentTypes: ['FX Spot'],
  },
  {
    id: SectionId.WITHDRAW_FROM_CUSTODIAN,
    title: 'Withdraw from Custodian',
    type: SectionType.SINGLE_COLUMN,
    visibleInInstrumentTypes: ['Transfer'],
  },
  {
    id: SectionId.DEPOSIT_TO_CUSTODIAN,
    title: 'Deposit to Custodian',
    type: SectionType.SINGLE_COLUMN,
    visibleInInstrumentTypes: ['Transfer'],
  },
  {
    id: SectionId.COMMISSION,
    title: 'Commission',
    type: SectionType.MATH_OPERATIONS,
    visibleInInstrumentTypes: [
      'Equities',
      'Funds & ETFs',
      'FixedIncome',
      'Option',
    ],
  },
  {
    id: SectionId.OTHER_CHARGES,
    title: 'Other Charges',
    type: SectionType.MATH_OPERATIONS,
    visibleInInstrumentTypes: [
      'Equities',
      'Funds & ETFs',
      'FixedIncome',
      'Transfer',
    ],
  },
  {
    id: SectionId.ACCRUED_INTEREST,
    title: 'Accrued Interest',
    type: SectionType.MATH_OPERATIONS,
    visibleInInstrumentTypes: ['FixedIncome'],
  },
  {
    id: SectionId.NOTE,
    title: 'Note',
    type: SectionType.SINGLE_COLUMN,
    visibleInInstrumentTypes: [
      'Equities',
      'Funds & ETFs',
      'FixedIncome',
      'Option',
      'FX Spot',
      'Deposit/Withdraw',
      'Transfer',
      'Cash Adjustments',
      'Dividend',
    ],
  },
  {
    id: SectionId.SETTLEMENT_ACCOUNT,
    title: 'Settlement Account',
    type: SectionType.MULTI_COLUMN_RULES_WITH_CATEGORIES,
    visibleInInstrumentTypes: [
      'Equities',
      'Funds & ETFs',
      'FixedIncome',
      'Cash Adjustments',
    ],
  },
  {
    id: SectionId.BUY_CURRENCY,
    title: 'Buy Currency',
    type: SectionType.CURRENCY,
    visibleInInstrumentTypes: ['FX Spot'],
  },
  {
    id: SectionId.SELL_CURRENCY,
    title: 'Sell Currency',
    type: SectionType.CURRENCY,
    visibleInInstrumentTypes: ['FX Spot'],
  },
  {
    id: SectionId.SETTLEMENT_CURRENCY,
    title: 'Settlement Currency',
    type: SectionType.CURRENCY,
    visibleInInstrumentTypes: ['Cash Adjustments'],
  },
  {
    id: SectionId.EX_DIVIDEND_DATE,
    title: 'Ex Dividend Date',
    type: SectionType.SINGLE_COLUMN_WITH_DATE,
    visibleInInstrumentTypes: ['Dividend'],
  },
  {
    id: SectionId.PAYMENT_DATE,
    title: 'Payment Date',
    type: SectionType.SINGLE_COLUMN_WITH_DATE,
    visibleInInstrumentTypes: ['Dividend'],
  },
  {
    id: SectionId.AWARDED_SHARES,
    title: 'Awarded Shares',
    type: SectionType.SINGLE_COLUMN,
    visibleInInstrumentTypes: ['Dividend'],
  },
  {
    id: SectionId.AWARDED_CASH,
    title: 'Awarded Cash',
    type: SectionType.SINGLE_COLUMN,
    visibleInInstrumentTypes: ['Dividend'],
  },
  {
    id: SectionId.TAX,
    title: 'Tax',
    type: SectionType.MATH_OPERATIONS,
    visibleInInstrumentTypes: ['Dividend'],
  },
];

export const getSectionsForInstrumentType = (
  instrumentType: UIInstrumentType
): SectionConfig[] => {
  return SECTION_CONFIGS.filter(section =>
    section.visibleInInstrumentTypes.includes(instrumentType)
  );
};
